import { slickDefaults } from '@/utils/carousel';

class HomeQuotes {
  constructor() {
    this.$el = $('.home-quotes');

    this.ui = {
      $items: $('.home-quotes__items', this.$el),
    };

    this.createCarousel();
  }

  createCarousel() {
    const $controls = $('<div class="slick-controls mx-auto" />');

    this.ui.$items
      .append($controls)
      .slick(slickDefaults({
        infinite: true,
        slidesToShow: 1,
        dots: true,
        slide: '.home-quotes__item',
        appendArrows: $controls,
        appendDots: $controls,
      }));
  }
}

export default HomeQuotes;
